module.exports = __webpack_public_path__ + "static/oh-the-places-you’ll-go-aabb81c1aef1889beb7f28ca0c8447c7.jpg";